export default "__VITE_ASSET__CHBAnqe0__"